import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    ReferenceField,
    required,
    SaveButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    Toolbar,
    useRecordContext,
    WrapperField,
} from 'react-admin'
import ActionButton from '../action'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.email}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <ReferenceField source='ad' reference='ads'>
                <WrapperField>
                    <SimpleShowLayout>
                        <TextField source='title' label='Title' />
                        <TextField source='type' label='Type' />
                    </SimpleShowLayout>
                </WrapperField>
            </ReferenceField>

            <InputGuesser label='Percent' source='percent' disabled fullWidth isRequired />
            <InputGuesser label='Start At' source='startAt' fullWidth isRequired />
            <InputGuesser label='End At' source='endAt' fullWidth isRequired />
            <InputGuesser label='Max usage' source='maxUsage' disabled fullWidth isRequired />

            <InputGuesser label='Active' source='active' fullWidth isRequired validate={[required()]} />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, children, ...props }) => (
    <Guesser {...props}>
        <ReferenceField source='ad' reference='ads'>
            <WrapperField>
                <SimpleShowLayout>
                    <TextField source='title' label='Title' />
                    <TextField source='type' label='Type' />
                </SimpleShowLayout>
            </WrapperField>
        </ReferenceField>

        <FieldGuesser label='Percent' source='percent' />
        <FieldGuesser label='Start At' source='startAt' />
        <FieldGuesser label='End At' source='endAt' />
        <FieldGuesser label='Max usage' source='maxUsage' />
        <FieldGuesser label='Active' source='active' />
        {children}
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => (
    <Fields Guesser={ShowGuesser} title={<Title />} {...props}>
        <ActionButton uri='validate' label='Valider' />
    </Fields>
)

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const Deal = {
    list: List,
    edit: Edit,
    create: Create,
    show: Show,
}

export default Deal
